import { createApi } from '@reduxjs/toolkit/query/react';

import { apiShifts } from '~constants/api';

import { Request, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';
import { get } from '~libs/genericAction';
import { createThunks, Params } from '~libs/reduxUtils';

import { ShiftWithTimes } from '~lookups/models';

export const typePrefix = 'shifts';

const config = [
  { actionType: 'getAll', apiPath: apiShifts, method: get },
  { actionType: 'getOne', apiPath: (params: Params) => `${apiShifts}/${params.id}`, method: get },
];

export const shiftsApi = createApi({
  reducerPath: 'shiftsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiShifts }),
  tagTypes: ['shifts'],
  endpoints: (builder) => ({
    // Returns every platform band with its default times and precedence, ordered by precedence.
    getShifts: builder.query<ShiftWithTimes[], Request | void>({
      query: (params) => ({ url: '', method: 'GET', params }),
      providesTags: [{ type: 'shifts', id: 'LIST' }],
      transformResponse: (payload) => unwrap<ShiftWithTimes[]>(payload),
    }),
  }),
});

export const { useGetShiftsQuery } = shiftsApi;

export const { getAll, getOne } = createThunks(typePrefix, config);
